<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="ha_code,ha_yearmonth"
      placeholder="输入编号、月份进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/oa/wage/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.wg_code}}</p>
          <p class="list-item-muted">{{item.wg_yearmonth}}</p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'#,##0.00'">{{item.wg_actwage}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.wg_status!='已审核'}"
          >{{item.wg_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}份</label>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/hr/wage/list",
      filters: [
        {
          type: "period",
          name: "wg_yearmonth"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "wg_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "wg_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>